export { default } from './index-default.js';
export * from './index.js';



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/index-all.js
// module id = 24
// module chunks = 13